// extracted by mini-css-extract-plugin
export default {"wrapper":"M_TreeHeader_wrapper__kWLEE","title":"M_TreeHeader_title__UWL-Y"};